export type NameType = 'initial';

export const name: NameType = 'initial';
